export default class {
  // Set initial vars
  constructor(el) {
    this.el = el;
    this.form = el.querySelector('#form');
    this.checkbox = el.querySelector('#gameTrax');
    this.successEl = el.querySelector('#success');
    this.success = false;
    this.actions = this.form.getAttribute('data-actions').split('|');
    this.actionFalse = this.actions[0];
    this.actionTrue = this.actions[1];
    const params = new URLSearchParams(window.location.search);
    if (params.get('success')) {
      this.success = true;
    }
  }

  // Initialize Module
  init() {

    // initially false
    form.setAttribute('action', this.actionFalse);

    const scope = this;

    // on change, update the action
    this.checkbox.addEventListener('change', function(e) {
      if (e.currentTarget.checked) {
        form.setAttribute('action', scope.actionTrue);
      } else {
        form.setAttribute('action', scope.actionFalse);
      }
    });

    if (this.success) {
      this.successEl.style.display = 'block';
      this.form.style.display = 'none';
    }
  }
}
